import React from 'react'
import { Typography, Button, makeStyles } from '@material-ui/core'
import { Box } from '@mui/material'
import { CheckCircleRounded, EditRounded } from '@material-ui/icons'
import { colors } from 'utils/colors'

const ThankYou = ({ onAction, subTitle }) => {
  const classes = useStyles()
  return (
    <Box className={classes.thankYou}>
      <CheckCircleRounded fontSize="large" className={classes.check} />
      <Typography className={classes.thanksText}>Thank You</Typography>
      <Typography className={classes.subText}>{subTitle}</Typography>

      <Button
        startIcon={<EditRounded />}
        className={classes.reqButton}
        variant="contained"
        onClick={onAction}>
        Edit Your Submitted Information
      </Button>
    </Box>
  )
}

export default ThankYou

const useStyles = makeStyles({
  thankYou: {
    marginTop: '5rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  check: {
    color: colors.indigo,
    fontSize: '125px'
  },
  thanksText: {
    marginTop: '0.5rem',
    fontSize: '28px',
    fontWeight: 'bold'
  },
  subText: {
    marginTop: '0.5rem',
    fontSize: '16px',
    textAlign: 'center',
    padding: '4px 16px'
  },
  reqButton: {
    marginTop: '1rem'
  }
})
